var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.terms = pt.blocografico.modules.terms || {};
pt.blocografico.modules.terms = (function () {
  function init() {
    const accordionButtons = document.querySelectorAll(".accordion .accordion-button");

    accordionButtons.forEach(function (accordionButton) {
      accordionButton.addEventListener("click", function () {
        if (window.innerWidth < 1148) {
          toggleAccordion(this, this.dataset.accordionToggle);
        }
      });
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 1148) {
        document.querySelectorAll(".accordion .accordion-content").forEach(function (accordionButton) {
          accordionButton.style.display = "block";
        });
      } else {
        document.querySelectorAll(".accordion .accordion-content").forEach(function (accordionButton) {
          accordionButton.style.display = "none";
        });
      }
    });
  }

  function toggleAccordion(item, itemId) {
    let content = document.getElementById(itemId);
    let arrow = item.querySelector(".arrow");
    arrow.classList.remove("up", "down");
    if (content.style.display === "block") {
      content.style.display = "none";
      arrow.classList.add("down");
    } else {
      content.scrollIntoView({ behavior: "smooth" });
      content.style.display = "block";
      arrow.classList.add("up");
    }
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelector(".accordion .accordion-button");
  if (accordion) {
    pt.blocografico.modules.terms.init();
  }
});
